// extracted by mini-css-extract-plugin
export var ellipsis = "pagination-module--ellipsis--d6530";
export var next = "pagination-module--next--8e545";
export var page = "pagination-module--page--733a7";
export var prev = "pagination-module--prev--7112f";
export var root = "pagination-module--root--a5c81";